import { Eyebrow } from './eyebrow';
import { Reveal } from './reveal';
import { cn } from '@/lib/cn';

type SectionIntroProps = {
  index: string;
  label?: string;
  title: string;
  intro?: string;
  tone?: 'light' | 'dark';
  titleClassName?: string;
};

export function SectionIntro({
  index,
  label,
  title,
  intro,
  tone = 'light',
  titleClassName,
}: SectionIntroProps) {
  return (
    <Reveal className="grid grid-cols-[repeat(auto-fit,minmax(min(100%,280px),1fr))] items-end gap-8">
      <div className="flex flex-col gap-6">
        <Eyebrow className={tone === 'dark' ? 'text-muted-invert' : undefined}>
          {index} / 07{label ? ` · ${label}` : ''}
        </Eyebrow>
        <h2 className={cn('max-w-[12ch] text-title font-light', titleClassName)}>{title}</h2>
      </div>
      {intro && (
        <p
          className={cn(
            'max-w-[44ch] justify-self-end text-body',
            tone === 'dark' ? 'text-muted-invert' : 'text-muted',
          )}
        >
          {intro}
        </p>
      )}
    </Reveal>
  );
}
